import { Button, Grid, Stack, styled, SxProps, Typography, Box } from '@mui/material';
import { titleSX, buttonSX, gridItemSX } from '@/components/blocks/DpLibrary/DpVideo/style/main';
import { combineSX } from '@/utils/combineSX';

const Video = styled('video')(({ theme }) => ({
	[theme.breakpoints.up('xs')]: {
		width: '100%',
	},
	[theme.breakpoints.up('sm')]: {
		width: '454px',
		height: '257px',
	},
}));

export const DpVideoDistribuidor = ({
	title,
	source,
	labelb,
	sxvideo,
	sxframe,
	sxpadding,
	href,
}: {
	title: string;
	source: string;
	labelb: string;
	sxvideo?: SxProps;
	sxframe?: SxProps;
	sxpadding?: SxProps;
	href: string;
}) => (
	<Grid
		xs={12}
		sm
		item
		display={'flex'}
		flexDirection={'column'}
		alignItems={'center'}
		sx={combineSX([gridItemSX, ...(Array.isArray(sxframe) ? sxframe : [sxframe])])}
	>
		<Box
			sx={{
				px: { xs: '0px', sm: '0px' },
			}}
		>
			<Stack
				sx={combineSX([
					{
						borderBottomLeftRadius: '8px',
						borderBottomRightRadius: '8px',
					},
					...(Array.isArray(sxpadding) ? sxpadding : [sxpadding]),
				])}
			>
				<Typography component="h2" sx={titleSX}>
					{title}
				</Typography>
				<Box>
					<Video
						src={source}
						loop
						controls
						muted
						sx={combineSX([...(Array.isArray(sxvideo) ? sxvideo : [sxvideo])])}
					></Video>
				</Box>
				<Stack sx={{ mt: '14px', mb: '20px', p: '0 45px' }}>
					<Button
						type="submit"
						variant="contained"
						sx={buttonSX}
						// disabled={submitting}
						href={href}
					>
						{labelb}
					</Button>
				</Stack>
			</Stack>
		</Box>
	</Grid>
);
